import React from 'react'
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import logofedpa from 'src/assets/fedpa.ico'
import { steps } from 'src/views/ChatBot/data';

const TheChatBot = () => {

    // all available props
    const theme = {
        background: '#f5f8fb',
        headerBgColor: '#0B3487',
        headerFontColor: '#fff',
        headerFontSize: '15px',
        botBubbleColor: '#0B3487',
        botFontColor: '#fff',
        userBubbleColor: '#fff',
        userFontColor: '#4a4a4a',
    };


    return (
        <div>
            <ThemeProvider theme={theme}>
                &nbsp;
                <ChatBot
                    headerTitle="ChatFedpa - version Beta"
                    placeholder="Escribe un mensaje"
                    floating
                    botAvatar={logofedpa}
                    steps={steps}
                />
            </ThemeProvider>
        </div>
    );
}

export default TheChatBot
